import { DashboardLayout } from 'features/common/ui/DashboardLayout'
import { AllAssetsPage } from 'pages/all-assets'
import { WrappedBoardPage } from 'pages/board'
import { FavoritesPage } from 'pages/favorites'
import InvitePage from 'pages/invite'
import { MyUploadsPage } from 'pages/my-uploads'
import { OfferPage } from 'pages/offer'
import { ProfilePage } from 'pages/profile'
import { WrappedPublicFilesPage } from 'pages/public-files'
import { RecentlyDeletedPage } from 'pages/recently-deleted'
import { RecentlyUploadedPage } from 'pages/recently-uploaded'
import { createBrowserRouter } from 'react-router-dom'
import { ROUTES } from 'shared/constants/routesPaths'
import { AiAssistantNewChatPage } from 'pages/ai-assistant-new-chat'
import { AiAssistantChatPage } from 'pages/ai-assistant-chat'

import Layout from './MainLayout'
import Home from './pages/home/Home'
import NotFound from './pages/NotFound'
import { SignupApprovalPage } from './pages/signup-approve'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
        handle: {
          title: 'Home'
        }
      },
      {
        path: 'dashboard',
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <AllAssetsPage />,
            handle: {
              title: 'All Assets'
            }
          },
          {
            path: ROUTES.dashboard.allAssets,
            element: <AllAssetsPage />,
            handle: {
              title: 'All Assets'
            }
          },
          {
            path: ROUTES.dashboard.favorites,
            element: <FavoritesPage />,
            handle: {
              title: 'Favorites'
            }
          },
          {
            path: ROUTES.dashboard.myUploads,
            element: <MyUploadsPage />,
            handle: {
              title: 'My Uploads'
            }
          },
          {
            path: ROUTES.dashboard.recentlyUploaded,
            element: <RecentlyUploadedPage />,
            handle: {
              title: 'Recently uploaded'
            }
          },
          {
            path: ROUTES.dashboard.recentlyDeleted,
            element: <RecentlyDeletedPage />,
            handle: {
              title: 'Recently deleted'
            }
          },
          {
            path: `${ROUTES.dashboard.board}/:id`,
            element: <WrappedBoardPage />,
            handle: {
              showBreadcrumbs: true
            }
          },
          {
            path: ROUTES.dashboard.aiAssistant,
            element: <AiAssistantNewChatPage />,
            handle: {
              title: process.env.APP_NAME
            }
          },
          {
            path: `${ROUTES.dashboard.aiAssistant}/:chatId`,
            element: <AiAssistantChatPage />,
            handle: {
              title: process.env.APP_NAME
            }
          },
        ]
      },
      {
        path: `${ROUTES.profile.prefix}`,
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <ProfilePage />,
            path: ':section',
            handle: {
              title: 'Profile'
            }
          },
        ]
      },
      {
        path: "/invite",
        element: <InvitePage />,
        handle: {
          title: 'Join Team'
        }
      },
      {
        path: "/links/fs/*",
        element: <WrappedPublicFilesPage />,
        handle: {
          title: 'Public Files'
        }
      },
      {
        path: "/offers/:offerId",
        element: <OfferPage />,
        handle: {
          title: 'Offer'
        }
      },
      {
        path: "/signup/approve",
        element: <SignupApprovalPage />,
        handle: {
          title: 'Signup Approval'
        }
      },
      // {
      //   path: "/mention",
      //   element: <MentionPage />,
      //   handle: {
      //     title: 'Mention Test'
      //   }
      // },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
    handle: {
      title: 'Page Not Found'
    }
  },
])
